import { useCallback, useLayoutEffect, useRef } from 'react';
import { useAeSaveContent, useEditorStore } from '@diana/core';

export const useSaveEditorBeforePublish = () => {
  const resolveListRef = useRef<Function[]>([]);

  const saveContent = useAeSaveContent();

  const isSaving = useEditorStore((s) => s.isSaving);

  useLayoutEffect(() => {
    if (!isSaving) {
      resolveListRef.current.forEach((resolve) => resolve());
      resolveListRef.current = [];
    }
  }, [isSaving]);

  return useCallback(() => {
    return new Promise<void>((resolve) => {
      const { selectedItemId, updates } = useEditorStore.getState();
      const hasPendingUpdate = selectedItemId ? !!updates[selectedItemId] : false;

      if (selectedItemId && hasPendingUpdate) {
        saveContent(selectedItemId);
        setTimeout(() => {
          if (!useEditorStore.getState().isSaving) resolve();
          else resolveListRef.current.push(resolve);
        });
      } else resolve();
    });
  }, [saveContent]);
};
